import { render, staticRenderFns } from "./TaxGroupFormTaxesSelector.vue?vue&type=template&id=04966ed0"
import script from "./TaxGroupFormTaxesSelector.vue?vue&type=script&lang=js"
export * from "./TaxGroupFormTaxesSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports